import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Css/Tickets.css"; // Import the CSS file
import tickitSvg from "../Images/Icon/tickets-icon.svg";
import alliconsImage1 from "../Images/Icon/allicons_0010_1.png";
import alliconsImage2 from "../Images/Icon/allicons_0010_3.png";
import alliconsImage3 from "../Images/Icon/allicons_0010_34.png";
import alliconsImage4 from "../Images/Icon/allicons_0010_35.png";
import alliconsImage5 from "../Images/Icon/allicons_0010_36.png";
import alliconsImage6 from "../Images/Icon/allicons_0010_37.png";
import alliconsImage7 from "../Images/Icon/allicons_0010_47.png";
import alliconsImage8 from "../Images/Icon/allicons_0010_72.png";
import alliconsImage9 from "../Images/Icon/allicons_0010_73.png";
import alliconsImage10 from "../Images/Icon/allicons_0010_85.png";

const Laws = () => {
  return (
    <div className="custom-container">
      <div className="custom-header text-center">
        <img src={tickitSvg} alt="Ticket" className="ticket-svg" />
        <h2 className="ticket-text">TICKETS</h2>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-3">
          <a
            href="https://pomsuat.mobilestyx.ca/police_app_peterborough/laws/law/1"
            class="text-decoration-none outline-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img
                  src={alliconsImage1}
                  className="card-img-top mb-2"
                />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">
                  COMPULSARY AUTOMOBILE INSURENCE ACT
                </h5>
              </div>
            </div>
          </a>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <a
            href="https://pomsuat.mobilestyx.ca/police_app_peterborough/laws/law/3"
            class="text-decoration-none outline-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img
                  src={alliconsImage2}
                  className="card-img-top mb-2"
                />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">
                  HIGHWAY TRAFFIC ACT
                </h5>
              </div>
            </div>
          </a>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <a
            href="https://pomsuat.mobilestyx.ca/police_app_peterborough/laws/law/34"
            class="text-decoration-none outline-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img
                  src={alliconsImage3}
                  className="card-img-top mb-2"
                />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">
                  LIQOUR LOCENCE AND CONTROL ACT
                </h5>
              </div>
            </div>
          </a>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <a
            href="https://pomsuat.mobilestyx.ca/police_app_peterborough/laws/law/35"
            class="text-decoration-none outline-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img
                  src={alliconsImage4}
                  className="card-img-top mb-2"
                />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">
                  TREEPASS TO PROPERTY ACT{" "}
                </h5>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12 col-md-6 col-lg-3">
          <a
            href="https://pomsuat.mobilestyx.ca/police_app_peterborough/laws/law/36"
            class="text-decoration-none outline-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img
                  src={alliconsImage5}
                  className="card-img-top mb-2"
                />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">
                  CANNABIS CONTROL ACT
                </h5>
              </div>
            </div>
          </a>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <a
            href="https://pomsuat.mobilestyx.ca/police_app_peterborough/laws/law/37"
            class="text-decoration-none outline-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img
                  src={alliconsImage6}
                  className="card-img-top mb-2"
                />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">SAFE STREETS ACT</h5>
              </div>
            </div>
          </a>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <a
            href="https://pomsuat.mobilestyx.ca/police_app_peterborough/laws/law/47"
            class="text-decoration-none outline-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img
                  src={alliconsImage7}
                  className="card-img-top mb-2"
                />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">BT LAWS</h5>
              </div>
            </div>
          </a>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <a
            href="https://pomsuat.mobilestyx.ca/police_app_peterborough/laws/law/72"
            class="text-decoration-none outline-none">
            <div className="custom-box card justify-content-start center px-3 py-4">
              <div className="card-img center">
                <img
                  src={alliconsImage8}
                  className="card-img-top mb-2"
                />
              </div>
              <div className="card-body p-0">
                <h5 className="card-title text-center m-0">SMOKE FREE ACT</h5>
              </div>
            </div>
          </a>
        </div>
        <div className="row mt-3">
          <div className="col-12 col-md-6 col-lg-3">
            <a
              href="https://pomsuat.mobilestyx.ca/police_app_peterborough/laws/law/73"
              class="text-decoration-none outline-none">
              <div className="custom-box card justify-content-start center px-3 py-4">
                <div className="card-img center">
                  <img
                    src={alliconsImage9}
                    className="card-img-top mb-2"
                  />
                </div>
                <div className="card-body p-0">
                  <h5 className="card-title text-center m-0">
                    ENVIROMENT PROTECTION ACT
                  </h5>
                </div>
              </div>
            </a>
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <a
              href="https://pomsuat.mobilestyx.ca/police_app_peterborough/laws/law/85"
              class="text-decoration-none outline-none">
              <div className="custom-box card justify-content-start center px-3 py-4">
                <div className="card-img center">
                  <img
                    src={alliconsImage10}
                    className="card-img-top mb-2"
                  />
                </div>
                <div className="card-body p-0">
                  <h5 className="card-title text-center m-0">
                    YOWING AND STORAGE SAFETY AND ENFORCEMENT ACT
                  </h5>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Laws;
